import http from "@http"

//列表  不分页
export function getBridgesTunnelsAll(data) {
    return http({
        url: '/lskj-data/api/data/bridgesTunnels/all',
        method: "post",
        data
    })
}
//列表  分页
export function getbridgesTunnelsList(data) {
    return http({
        url: '/lskj-data/api/data/bridgesTunnels/list',
        method: "post",
        data
    })
}

//查询单条
export function bridgesTunnelsById(data) {
    return http({
        url: `/lskj-data/api/data/bridgesTunnels/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function bridgesTunnelsAdd(data) {
    return http({
        url: '/lskj-data/api/data/bridgesTunnels/add',
        method: "post",
        data
    })
}

//修改
export function updeteBridgesTunnels(data) {
    return http({
        url: `/lskj-data/api/data/bridgesTunnels`,
        method: "put",
        data
    })
}
//删除
export function deleteBridgesTunnels(data) {
    return http({
        url: `/lskj-data/api/data/bridgesTunnels?ids=${data.ids}`,
        method: "delete",
        data
    })
}